// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslation from "../locales/en/translation.json";
import roTranslation from "../locales/ro/translation.json";
import deTranslation from "../locales/de/translation.json";
import esTranslation from "../locales/es/translation.json";
import frTranslation from "../locales/fr/translation.json";
import itTranslation from "../locales/it/translation.json";
import zhTranslation from "../locales/zh/translation.json";

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: enTranslation
            },
            ro: {
                translation: roTranslation
            },
            de: {
                translation: deTranslation
            },
            es: {
                translation: esTranslation
            },
            fr: {
                translation: frTranslation
            },
            it: {
                translation: itTranslation
            },
            zh: {
                translation: zhTranslation
            },
        },
        lng: "en",
        fallbackLng: "en",
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
